// extracted by mini-css-extract-plugin
export default {"StickyHeader":"TableHeader_StickyHeader__TJsgE","FixedHeader":"TableHeader_FixedHeader__xfmt0"};